import {
    GETPROFILE_REQUEST,
    GETPROFILE_SUCCESS,
    GETPROFILE_FAILURE,
    REQUEST_PIN_SUCCESS,
    LINK_CUSTOMER_FAILURE,
    LINK_CUSTOMER_REQUEST,
    LINK_CUSTOMER_SUCCESS,
    REQUEST_PIN_REQUEST,
    REQUEST_PIN_FAILURE,
    REQUEST_PASSWORD_RECOVERY_PIN_REQUEST,
    REQUEST_PASSWORD_RECOVERY_PIN_SUCCESS,
    REQUEST_PASSWORD_RECOVERY_PIN_FAILURE,
    RECOVER_PASSWORD_REQUEST,
    RECOVER_PASSWORD_SUCCESS,
    RECOVER_PASSWORD_FAILURE,
    SUBSCRIBE_SUPERVECTORING_REQUEST,
    SUBSCRIBE_SUPERVECTORING_SUCCESS,
    SUBSCRIBE_SUPERVECTORING_FAILURE,
} from 'api/index';

const initialSettings = null;

const profile = (state = initialSettings, action) => {
    switch (action.type) {
        case GETPROFILE_SUCCESS:
            return action.payload;

        case REQUEST_PIN_REQUEST:
        case REQUEST_PIN_SUCCESS:
        case REQUEST_PASSWORD_RECOVERY_PIN_REQUEST:
        case REQUEST_PASSWORD_RECOVERY_PIN_SUCCESS:
            return {
                ...state,
                verification: action.payload,
                requestPinFailed: false,
                linkCustomerFailed: false,
                recoverPasswordFailed: false,
            };
        case REQUEST_PIN_FAILURE:
        case REQUEST_PASSWORD_RECOVERY_PIN_FAILURE:
            return {
                ...state,
                verification: null,
                requestPinFailed: true,
                linkCustomerFailed: false,
                recoverPasswordFailed: false,
            };

        case LINK_CUSTOMER_REQUEST:
        case LINK_CUSTOMER_SUCCESS:
            return {
                ...state,
                linkCustomerFailed: false,
            };
        case LINK_CUSTOMER_FAILURE:
            return {
                ...state,
                linkCustomerFailed: true,
            };

        case RECOVER_PASSWORD_REQUEST:
        case RECOVER_PASSWORD_SUCCESS:
            return {
                ...state,
                recoverPasswordFailed: false,
            };
        case RECOVER_PASSWORD_FAILURE:
            return {
                ...state,
                recoverPasswordFailed: true,
            };
    
        default:
            return state;
    }
};

export default profile;